export const PLANNER_COLORS = {
  blue: '#2f81f7',
  green: '#3fb950',
  orange: '#f0883e',
  red: '#f85149',
  purple: '#a371f7',
  yellow: '#d29922',
  teal: '#39d353',
  grey: '#5b6478',
};

export const tint = (hex) => `${hex}26`;
